import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class ViewApplicationStakeholdersItamsConstants {
    static STEP_TITLE = "Traders";
    static SAVE_BUTTON_PLACEHOLDER = SharedConstants.SAVE_LABEL;
    static TRADERS_LABEL = "Traders";
    static TRADER_FORM_ARRAY_NAME = "traders";
    static TRADERS_LOOKUP_NAME = "Traders";
    static TRADERS_CONTROL_NAME = "traders";
    static TRADERS_FORM_GROUP_NAME = "tradersForm";
    static DETAILS_FORM_GROUP_NAME = "details";
    static APPLICATION_ERROR_MESSAGE = "An application needs to have at minimum 1 trader";
}
